import { configureStore } from '@reduxjs/toolkit'
import storeReducer from './storeSlice.ts'
import userReducer from './userSlice.ts'
import seatingReducer from './seatingSlice.ts'

export const store = configureStore({
	reducer: {
		appData: storeReducer,
		userData: userReducer,
		seating: seatingReducer
	}
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
